import { render, staticRenderFns } from "./svgBase.vue?vue&type=template&id=3019aec6&scoped=true"
import script from "./svgBase.vue?vue&type=script&lang=js"
export * from "./svgBase.vue?vue&type=script&lang=js"
import style0 from "./svgBase.vue?vue&type=style&index=0&id=3019aec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019aec6",
  null
  
)

export default component.exports